import moment from "moment/moment";

export const formatTimezoneOffset = (offset) => {
  offset = offset.trim();

  const hasSign = offset.startsWith('+') || offset.startsWith('-');
  const sign = hasSign ? offset[0] : '+';
  const numberPart = hasSign ? offset.substring(1) : offset;

  const hours = parseInt(numberPart, 10);
  const formattedHours = Math.abs(hours).toString().padStart(2, '0');

  return sign === '-' ? `-${formattedHours}:00:00` : `${formattedHours}:00:00`;
};

export const formatDate = (dateString) => {
  if (!dateString) return '';

  const date = moment(dateString);
  if (date.isValid()) {
    return date.format('DD.MM.YYYY HH:mm:ss');
  }

  return dateString;
};
